import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DEPARTMENT_TYPE_YOUTH } from 'src/app/core/constants';

@Component({
    selector: 'app-youth-attached',
    templateUrl: './youth-attached.component.html',
    styleUrls: ['./youth-attached.component.scss'],
})
export class YouthAttachedComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Juvenil
     */
    public departmentType: string = DEPARTMENT_TYPE_YOUTH;

    /**
     * Definição do parâmetro recebido via url através do menu sidebar
     */
    public sessionType;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.params.subscribe((params) => (this.sessionType = params['sessionType']));
        //console.log('sessionType=' + this.sessionType);
    }
}
